import { bsMath, formatTokenAmount, formatUsd } from "@bridgesplit/utils";
import { Row, Text, TextVariant } from "@bridgesplit/ui";
import { TokenListMetadata } from "@bridgesplit/abf-sdk";

import { LoopDisplayType } from "../../common/loop";
import { LoopExecutionDetails } from "./types";
import { WIDE_ROW_STYLE, FORMAT_OPTIONS } from "./formatters";

export function ReceiveOnCloseDisplay({
    executionDetails,
    principalToken,
    principalUsdPrice,
    displayType,
    setDisplayTypeHandler,
    receiveTokenAmount,
    leftOverPrincipal,
    textVariant,
    receiveToken
}: {
    executionDetails: LoopExecutionDetails | undefined;
    displayType: LoopDisplayType;
    setDisplayTypeHandler: () => void;
    receiveTokenAmount: number | undefined;
    leftOverPrincipal: number | undefined;
    principalToken: TokenListMetadata | undefined;
    principalUsdPrice: number | undefined;
    textVariant: TextVariant;
    receiveToken: TokenListMetadata | undefined;
}) {
    if (!executionDetails) return <Text>--</Text>;

    if (displayType === LoopDisplayType.UsdCostBasis) {
        // For USD display, show the total receive amount in USD
        return (
            <Text variant={textVariant} translate="no" onClick={() => setDisplayTypeHandler()}>
                {formatUsd(executionDetails.receiveUsdAmount || 0)}
            </Text>
        );
    }

    const leftOverPrincipalAmount = bsMath.div(leftOverPrincipal, principalUsdPrice);

    return (
        <Row sx={WIDE_ROW_STYLE} spacing={0.5}>
            <Text variant={textVariant} translate="no" onClick={() => setDisplayTypeHandler()}>
                {formatTokenAmount(receiveTokenAmount, {
                    symbol: receiveToken?.symbol,
                    ...FORMAT_OPTIONS
                })}
            </Text>
            {leftOverPrincipalAmount > 0 && (
                <Text variant={textVariant} onClick={() => setDisplayTypeHandler()}>
                    {"+ "}
                    {formatTokenAmount(leftOverPrincipalAmount, {
                        symbol: principalToken?.symbol,
                        ...FORMAT_OPTIONS
                    })}
                </Text>
            )}
        </Row>
    );
}
